import { FC, useState, createContext, useContext } from 'react'
import { QueryState, WithChildren, QueryStateI } from '../../../../../general/helpers'
import { SELECTED_STORAGE_KEYS } from '../../../auth/core/constant'
import momentTimezone from 'moment-timezone'
import { parseJwt } from '../../core/helper'

interface QueryRequestContextI {
    state: QueryStateI & { [key: string]: string | number }
    updateState: (updates: Partial<QueryStateI>, persistOldValues?: boolean) => void
    loading?: boolean
    toggleLoading?: () => void
}

const QueryRequestContext = createContext<QueryRequestContextI>({
    state: { page: 1, size: 20 },
    updateState: () => { },
    loading: false,
    toggleLoading: () => { },
})

const PromotionsQueryRequestProvider: FC<WithChildren> = ({ children }) => {
    const localFilters = sessionStorage.getItem(SELECTED_STORAGE_KEYS.PROMOTIONS_FILTERS_KEY)
    const token = localStorage.getItem('kt-auth-react-v') ? JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.accessToken : ''
    const { activeRetailer } = parseJwt(token ?? '')
    const today = momentTimezone().tz(activeRetailer?.timeZone).startOf('day').toISOString()

    const defaultFilter = {
        // "creationStartDateTime.greaterThanOrEqual": today, // Disable default pre-population
        page: 1,
        size: 20,
    }

    const [state, setState] = useState<QueryStateI & { [key: string]: string | number }>(
        localFilters
            ? JSON.parse(localFilters)
            : defaultFilter
    )
    const [loading, setLoading] = useState<boolean>(true)

    const updateState = (updates: Partial<QueryState>, persistOldValues: boolean = true) => {
        let updatedState = { ...state, ...updates } as QueryStateI & { [key: string]: string | number }
        if (!persistOldValues) {
            updatedState = { ...updates } as QueryStateI & { [key: string]: string | number }
        }
        sessionStorage.setItem(SELECTED_STORAGE_KEYS.PROMOTIONS_FILTERS_KEY, JSON.stringify(updatedState))
        setState(updatedState)
    }

    const toggleLoading = () => setLoading((prev) => !prev)

    return (
        <QueryRequestContext.Provider value={{ state, updateState, loading, toggleLoading }}>
            {children}
        </QueryRequestContext.Provider>
    )
}

const usePromotionsQueryRequest = () => useContext(QueryRequestContext)
export { PromotionsQueryRequestProvider, usePromotionsQueryRequest }
